module.exports = __webpack_public_path__ + "static/media/horrormax-banner-the-night-he-came-home.8b72a164.jpg";